import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "component-socket-values-wrapper__list" };
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import { isBuiltCampaignComponentSocket } from "src/shared/store/component-built/setting/model/BuiltCampaignComponentSocket";
import { useComponentType } from "src/shared/store/component-type/composables/useComponentType";
import { navigateToNewSocketChildComponentDrawerRoute, navigateToViewComponentDrawerRoute, } from "src/shared/v-components/component/component-drawer/componentDrawerRoutes";
import Button from "src/shared/v-components/ui/Button.vue";
import { computed } from "vue";
import { useRouter } from "vue-router";
import ComponentSocketValue from "./ComponentSocketValue.vue";
import { confirmRemoveInstalledComponent } from "./operations";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentSocketValues',
    props: {
        componentId: {},
        settingName: {},
        componentDrawerRouteConfig: {},
        size: { default: "medium" }
    },
    setup(__props) {
        const props = __props;
        const { builtComponent } = useBuiltComponent(props.componentId);
        const setting = computed(() => { var _a; return (_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.findSetting(props.settingName); });
        const socketFilterComponentType = computed(() => {
            if (!setting.value || !isBuiltCampaignComponentSocket(setting.value)) {
                return null;
            }
            return setting.value.filter.component_type;
        });
        const { componentType } = useComponentType(() => socketFilterComponentType.value);
        const installedComponentIds = computed(() => {
            if (!setting.value || !isBuiltCampaignComponentSocket(setting.value)) {
                return [];
            }
            return setting.value.getInstalledComponentIds();
        });
        const router = useRouter();
        const navigateToViewComponent = (componentId) => {
            if (!props.componentDrawerRouteConfig)
                return;
            navigateToViewComponentDrawerRoute(componentId, props.componentDrawerRouteConfig, router);
        };
        const navigateToNewSocketChildComponentRoute = () => {
            if (!props.componentDrawerRouteConfig)
                return;
            if (!setting.value || !isBuiltCampaignComponentSocket(setting.value))
                return;
            navigateToNewSocketChildComponentDrawerRoute(setting.value.context.componentId, setting.value.name, props.componentDrawerRouteConfig, router);
        };
        return (_ctx, _cache) => {
            return (_unref(componentType) && _unref(builtComponent))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["component-socket-values-wrapper", `component-socket-values-wrapper--${_ctx.size}`])
                }, [
                    _createElementVNode("ul", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(installedComponentIds.value, (id, i) => {
                            return (_openBlock(), _createBlock(ComponentSocketValue, {
                                key: i,
                                componentId: id,
                                size: _ctx.size,
                                settingName: _ctx.settingName,
                                componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig,
                                onNavigateToViewComponent: navigateToViewComponent,
                                onConfirmDeleteInstalledComponent: () => {
                                    _unref(confirmRemoveInstalledComponent)({
                                        componentId: _ctx.componentId,
                                        targetComponentId: id,
                                        settingName: _ctx.settingName,
                                    });
                                }
                            }, null, 8 /* PROPS */, ["componentId", "size", "settingName", "componentDrawerRouteConfig", "onConfirmDeleteInstalledComponent"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    (_unref(componentType) && _ctx.size === 'medium')
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            disabled: !_ctx.componentDrawerRouteConfig,
                            onClick: navigateToNewSocketChildComponentRoute,
                            level: 'bordered'
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" + New " + _toDisplayString(_unref(componentType).getDisplayName()), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled"]))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true);
        };
    }
});
